import http from '../../../http/base';
import { API_PATHS } from '../../../http/configs';
import { TAKEN_COUNT } from '../../../constants/dropdown';

export function getFacilities(filter, afOnly) {
    return http.get(API_PATHS.facilityDropdownList, { params: { searchTerm: filter, takeCount: TAKEN_COUNT, afOnly } });
}
